import {
  IonButton,
  IonCard,
  IonCardContent,
  IonIcon,
  IonItem,
  IonLabel,
} from "@ionic/react";
import { checkmarkCircleOutline, trashOutline } from "ionicons/icons";
import React from "react";
import { TiDelete } from "react-icons/ti";
import { hapticPatterns } from "../../utils/haptics";
import { shouldUseIonicComponents } from "../../utils/platformUtils";
import { Aa } from "../functions/Aa";

const AddressItem = ({ item, isSelected, onSelect, onDelete }) => {
  const useMobileUI = shouldUseIonicComponents();

  const handleSelect = async () => {
    if (useMobileUI) {
      await hapticPatterns.selection();
    }
    onSelect();
  };

  const handleDelete = async (e) => {
    e.stopPropagation();
    if (useMobileUI) {
      await hapticPatterns.buttonClick();
    }
    onDelete();
  };

  if (useMobileUI) {
    return (
      <IonCard
        onClick={handleSelect}
        color={isSelected ? "success" : "light"}
        style={{ position: "relative", margin: "10px 0" }}
      >
        {isSelected && (
          <IonIcon
            icon={checkmarkCircleOutline}
            color="success"
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              fontSize: "24px",
            }}
          />
        )}
        <IonCardContent>
          <IonItem lines="none">
            <IonLabel>
              <strong>Receiver:</strong> {Aa(item?.receiver_name)}
            </IonLabel>
          </IonItem>
          <IonItem lines="none">
            <IonLabel>
              <strong>Phone:</strong> {Aa(item?.phone_number)}
            </IonLabel>
          </IonItem>
          <IonItem lines="none">
            <IonLabel>
              <strong>Street:</strong> {Aa(item?.street_name)}
            </IonLabel>
          </IonItem>
          <IonItem lines="none">
            <IonLabel>
              <strong>Address:</strong> {Aa(item?.line_address)}
            </IonLabel>
          </IonItem>
          <IonItem lines="none">
            <IonLabel>
              <strong>Instructions:</strong> {Aa(item?.instruction)}
            </IonLabel>
          </IonItem>
        </IonCardContent>
        <IonButton
          size="small"
          color="danger"
          onClick={handleDelete}
          style={{ position: "absolute", bottom: "10px", right: "10px" }}
        >
          <IonIcon icon={trashOutline} />
        </IonButton>
      </IonCard>
    );
  }

  return (
    <div
      onClick={() => {
        onSelect();
      }}
      className="address-item"
    >
      <div
        className="address-item__delete-btn profil-delete-btn"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
      >
        <TiDelete size={30} color={"#ff114d"} />
      </div>
      <span>{Aa(item?.receiver_name)},</span>
      <span>{Aa(item?.phone_number)},</span>
      <span>{Aa(item?.street_name)},</span>
      <span>{Aa(item?.line_address)},</span>
      <span>{Aa(item?.instruction)}</span>
      <div
        className={`address-item__indicator ${
          isSelected ? "address-item__indicator--selected" : ""
        }`}
      ></div>
    </div>
  );
};

export default AddressItem;
